export const GET_ALL_USERS = "get/all/users";
export const ADD_USERS = "add/users";
export const UPDATE_USERS = "update/users";
export const DELETE_USERS = "delete/users";
export const LOADING_USERS = "loading/users";
export const ERROR_USERS = "error/users";
export const RESET_USERS = "reset/users";
